import React from "react";

interface SurveyPreviewBaseQuestionProps {
  question: string;
  description: string;
}
export const SurveyPreviewBaseQuestion = ({ question, description }: SurveyPreviewBaseQuestionProps) => {
  return (
    <label className="text-heading mb-1.5 block text-base font-semibold leading-6">
      <div className="flex items-center  justify-between">{question}</div>
      <label className="text-subheading block text-sm font-normal leading-6">{description}</label>
    </label>
  );
};
